import { CP_API_TESTNET, NETWORKS } from "../const/general";
import { TRX_TOKENS } from "../const/tokens";
const { tronWeb } = window;

export const isTronLinkInstalled = () => Boolean(tronWeb && tronWeb.defaultAddress.base58);

export const connectTronWallet = async (currency) => {
  if (!isTronLinkInstalled())  return null;

  const address = tronWeb.defaultAddress.base58;
  return getTronBalance(address, currency);
};

export const getTronWallet = async (currency) => {
  if (!isTronLinkInstalled())  return null;

  const address = tronWeb.defaultAddress.base58;
  return getTronBalance(address, currency);
};

export const getTronBalance = async (account, tokenName) => {
  if (!isTronLinkInstalled())  return null;

  let balance;

  if (tokenName === NETWORKS.TRX[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].SYMBOL) {
    balance = await tronWeb.trx.getBalance(account).then((balance) => balance);
  } else {
    const tronClient = await tronWeb.trx.getContract(TRX_TOKENS[tokenName][CP_API_TESTNET ? 'TESTNET' : 'MAINNET']);
    const contract = await tronWeb.contract(tronClient.abi.entrys, TRX_TOKENS[tokenName][CP_API_TESTNET ? 'TESTNET' : 'MAINNET']);
    balance = await contract.balanceOf(account).call();
  }

  return { address: account, balance: balance.div(10**6).toString() }
};

export const tronCreateTransaction = async (from, to, value, currency) => {
  if (!isTronLinkInstalled())  return null;

  try {
    if (currency === NETWORKS.TRX[CP_API_TESTNET ? 'TESTNET' : 'MAINNET'].SYMBOL) {
      const tx = await tronWeb.transactionBuilder.sendTrx(to, BigInt(Number(value) * 10**6).toString(), from);
      const signedTx = await tronWeb.trx.sign(tx);
      await tronWeb.trx.sendRawTransaction(signedTx);
    } else {
      const tronClient = await tronWeb.trx.getContract(TRX_TOKENS[currency][CP_API_TESTNET ? 'TESTNET' : 'MAINNET']);
      const contract = await tronWeb.contract(tronClient.abi.entrys, TRX_TOKENS[currency][CP_API_TESTNET ? 'TESTNET' : 'MAINNET']);
      const decimal = await contract.decimals().call();
      await contract.transfer(to, BigInt(Number(value) * 10**decimal).toString()).send();
    }
  } catch (error) {
    throw(error);
  }
};

